<template>
  <div style="background:#fff">
    <div class="error_404">
      <img src="@/assets/404.png" alt />
      <p>抱歉...您访问的页面走丢了</p>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.error_404 {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999999;
  font-size: 18px;
}
.error_404 img {
  width: 150px;
  height: 220px;
}
</style>
